module.exports = __webpack_public_path__ + "img/shopping-cart-fill.882474a6.svg";